import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";
import Navbar from "../components/navbar";
import GalleryCard from "../components/gallery-card2";
import LiveStream from "../components/live-stream";
import "./home.css";
import GetWidth from "../components/hook/width";


const Home = (props) => {
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    const checkLive = () => {
      const forceShow = process.env.REACT_APP_IS_LIVE === 'true';
      if (forceShow) {
        setIsLive(true);
        return;
      }

      const now = new Date();
      const start = new Date(process.env.REACT_APP_START_TIME || '2026-03-15T09:00:00+05:30');
      const end = new Date(process.env.REACT_APP_END_TIME || '2026-03-15T18:00:00+05:30');
      setIsLive(now >= start && now <= end);
    };

    checkLive();
    const interval = setInterval(checkLive, 30000);
    return () => clearInterval(interval);
  }, []);

  const getCurrentYear = () => {
    return new Date().getFullYear().toString();
  };
const width = GetWidth();
const isMobile = width < 745;
//add any future event here :)
  const events = [
  {
    heading: "Lovers' Quarrel 2025 | Day 1",
    imageSrc: "https://img.youtube.com/vi/hH6zp0jJFfo/maxresdefault.jpg",
    link: "https://www.youtube.com/watch?v=hH6zp0jJFfo",
  },
  {
    heading: "Lovers' Quarrel 2025 | Day 2",
    imageSrc: "https://i.ytimg.com/vi/2cL4ZwlYApc/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=2cL4ZwlYApc",
  },
  {
    heading: "Lovers' Quarrel 2025 | Day 3",
    imageSrc: "https://i.ytimg.com/vi/m4hivxlyh64/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=m4hivxlyh64",
  },
  {
    heading: "One Day Encounter 2025",
    imageSrc: "https://i.ytimg.com/vi/PwMKQNGgzf4/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=PwMKQNGgzf4",
  },
  {
    heading: "T.V. Sumanasekara Trophy 2025",
    imageSrc: "https://i.ytimg.com/vi/k46cZmOq5oE/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=k46cZmOq5oE",
  },
  {
    heading: "Richmond's Favourites",
    imageSrc: "https://i.ytimg.com/vi/Wrx2uENqVow/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=Wrx2uENqVow&list=PLEo03k1ABli5QuJXIkVVcO_VAOSAtvSe7",
  },
];


  return (
    <div className="home-container">
      <Helmet>
        <title>Richmond Live</title>
        <meta property="og:title" content="Richmond Live" /> 
      </Helmet>
      
      {isLive && <LiveStream />}
      {!isLive && (
      <section className="home-hero">
        <Navbar />
        <div className="home-background"></div>
        <div className="home-hero-content">
          <h1 className="home-text01">
            <span className="home-text02">
              Sri Lanka&apos;s
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
            <span className="home-text03">Premium</span>
            <span className="home-text04"> School Broadcasting Team </span>
          </h1>
          <div className="home-caption">
            <button className="home-register1 button-style-1 button">
              <span className="home-text05">Text</span>
            </button>
            <p className="home-caption1">
              <span className="home-text06">
                Lovers&apos; Quarrel {getCurrentYear()}
              </span>
              <br className="home-text07"></br>
              <span className="home-text08">
                Catch the action live on loversquarrel.lk
              </span>
              <br></br>
            </p>
          </div>
        </div>
      </section>
      )}
      <section className="home-notes">
        <div id="about-section" className="home-first home-about">
          <div data-aos="fade-up-right" className="home-content">
            <h2 className="home-header">How we Think Beyond the Trend:</h2>
            <span className="home-text10">
              <span>
                Welcome to the webpage of Richmond Live, your premier source for
                live coverage of the Richmond Mahinda Lovers’ Quarrel!
              </span>
              <br className="home-text12"></br>
              <br></br>
              <span>
                Our team is made up of talented students from Richmond College
                who are passionate about webcasting and provide live coverage of
                this exciting event. We believe that the Richmond Mahinda
                Lovers’ Quarrel is one of the most thrilling events in the
                school calendar, and we are dedicated to bringing you all the
                action as it happens from the toss to the stumps.
              </span>
              <br className="home-text15"></br>
              <br></br>
              <span>
                At Richmond Live, we are committed to showcasing the best of the
                Richmond Mahinda Lovers Quarrel and providing a platform for the
                talented students who participate in this event. We believe that
                the event not only brings the school community together, but
                also fosters a spirit of friendly competition and sportsmanship.
              </span>
              <br className="home-text18"></br>
              <br></br>
              <span>
                Whether you&apos;re a student, a parent, or an alum of Richmond
                College, we invite you to tune in to our live coverage of the
                Richmond Mahinda Lovers Quarrel. Join us as we celebrate the
                talents and spirit of our students and cheer on our teams to
                victory! Cheer Richmond!
              </span>
              <br className="home-text21"></br>
              <br></br>
            </span>
            <div className="home-list">
              <div className="home-note">
                <div className="home-point"></div>
              </div>
              <div className="home-note1">
                <div className="home-point1"></div>
              </div>
            </div>
          </div>
          <img
            alt="image"
            src="https://i.imgur.com/IxikjDE.jpg"
            loading="eager"
            className="home-image1 image-notes"
          />
        </div>
        <section className="home-watch">
          <h2 className="home-title">Past Events</h2>
            <div className="home-gallery">
              {events
                .slice(0, isMobile ? 4 : 6)
                .map((event) => (
                  <GalleryCard
                    key={event.id}
                    heading={event.heading}
                    imageSrc={event.imageSrc}
                    link={event.link}
                  />
                ))}
            </div>

        </section>
      </section>
      <section className="home-watch1">
        <div className="home-content1">
          <span className="home-text23 team-section-title-2">
            Thinking Beyond the Trend...
          </span>
          <h1 className="home-text24">
            <span className="home-text25 team-section-title-1">
              Team Richmond Live
            </span>
            <br></br>
          </h1>
          <div className="home-video">
            <iframe
              width="100%"
              height="480"
              src="https://www.youtube.com/embed/7EcF_uzQX4k?rel=0"
              title="Team Richmond Live"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <footer className="home-footer">
          <span className="home-copyright">
            {" "}
            © {getCurrentYear()} Richmond Live. All Rights Reserved.    |   
            Designed and developed by Digital Operations Team.
          </span>
        </footer>
      </section>
      <div
        dangerouslySetInnerHTML={{
          __html: `<script>
      ScrollReveal().reveal('.speaker');
      ScrollReveal().reveal('.image-notes');
    </script>`,
        }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: `<style>
      #scrollbar::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
      }
      #scrollbar::-webkit-scrollbar {
        height: 12px;
        background-color: #F5F5F5;
        border-radius: 10px;
      }
      #scrollbar::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #555;
      }
    </style>`,
        }}
      />
    </div>
  );
};

export default Home;